import React from "react";
import parentServices from "../../../../../services/parent-services";
import {
  Elements,
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import LoadingButton from "@mui/lab/LoadingButton";
import { useTranslation } from "react-i18next";
import Div from "@jumbo/shared/Div";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Divider,
  FormControl,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import Stack from "@mui/material/Stack";
import { COUNTRIES } from "../../../../../utils/constants/appActions";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const PaymentModel = ({ plan, hide }) => {
  const stripe = useStripe();
  const [errMsg, setErrMsg] = React.useState("");
  const [paymentProcessing, setPaymentProcessing] = React.useState(false);
  const elements = useElements();
  const baseUrl = window.location.origin;
  const { t } = useTranslation();

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    setPaymentProcessing(true);
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const result = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: baseUrl + "/parent/complete/payment",
      },
    });

    if (result.error) {
      // Show error to your customer (for example, payment details incomplete)
      setErrMsg(result.error.message);
      console.log(result.error.message);
      setPaymentProcessing(false);
    } else {
      window.location = "/dashboard/subscription";
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  };

  return (
    <Div
      sx={{
        width: "100%",
        backgroundColor: "rgb(255, 255, 255)",
        borderRadius: "18px",
        px: { xs: 3, sm: 4, md: 3 },
        pt: 3,
        pb: 3,
        minHeight: "auto",
      }}
    >
      {/* Title */}
      <Typography
        sx={{
          display: "block",
          fontFamily: "Nunito, sans-serif",
          fontSize: "20px",
          fontWeight: 800,
          color: "rgb(0, 36, 101)",
          textAlign: "center",
          mb: 2,
        }}
      >
        {t("payment-modal.paymentTitle")}
      </Typography>

      <Divider sx={{ mb: 3, borderColor: "rgb(229, 231, 235)" }} />

      <Box
        component="form"
        onSubmit={handleSubmit}
        noValidate
        autoComplete="off"
      >
        {/* Form */}
        <Box sx={{ p: 1.5 }}>
          <PaymentElement />

          {/*<Stack sx={{ width: "100%", mt: 2 }} spacing={2}>
            {errMsg && <Alert severity="error">{errMsg}</Alert>}
          </Stack>*/}
        </Box>

        <Stack
          direction="row"
          spacing={2}
          sx={{ pt: 1.5, justifyContent: "center" }}
        >
          <Button
            onClick={() => {
              hide({ backToAddress: true });
            }}
            sx={{
              flex: 1,
              maxWidth: 260,
              backgroundColor: "rgb(224, 224, 224)",
              borderRadius: "10px",
              fontSize: "14px",
              fontWeight: 600,
              fontFamily: "Nunito, sans-serif",
              color: "rgb(102,102,102)",
              height: 44,
              "&:hover": { backgroundColor: "rgb(219, 219, 219)" },
            }}
          >
            {t("payment-modal.back")}
          </Button>

          <LoadingButton
            disabled={!stripe}
            loading={paymentProcessing}
            variant="contained"
            type="submit"
            sx={{
              flex: 1,
              maxWidth: 260,
              bgcolor: "rgb(29,106,222)",
              borderRadius: "10px",
              bgcolor: "rgb(29,106,222)",
              fontSize: "14px",
              fontWeight: 600,
              fontFamily: "Nunito, sans-serif",
              color: "rgb(255,255,255)",
              height: 44,
              "&:hover": { backgroundColor: "rgb(30, 79, 214)" },
            }}
          >
            {t("payment-modal.pay")}
          </LoadingButton>
        </Stack>
      </Box>
    </Div>
  );
};
const PaymentStripe = ({ hide, plan, discountCode, address }) => {
  const [options, setOptions] = React.useState("");
  const { i18n } = useTranslation();

  const stripeLocale = React.useMemo(() => {
    const lang = (i18n.language || "en").toLowerCase();

    if (lang.startsWith("fr")) return "fr";
    return "en";
  }, [i18n.language]);

  React.useEffect(async () => {
    if (plan?.planId) {
      const response = await parentServices.loadSecret({
        discountCode,
        amount: plan.amount,
        planId: plan.planId,
        address: {
          address1: address?.address1 || "",
          address2: address?.address2 || "",
          city: address?.city || "",
          postalCode: address?.postalCode || "",
          country: address?.country || address?.countryObj?.code || "",
        },
      });
      setOptions({ clientSecret: response.secret, locale: stripeLocale });
    }
  }, [plan]);

  console.log(options);

  if (options && !!plan?.planId) {
    return (
      <Elements stripe={stripePromise} options={options}>
        <PaymentModel hide={hide} plan={plan} address={address} />
      </Elements>
    );
  }

  return null;
};
export default PaymentStripe;
